import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input()
  headerLight: string;

  @Input()
  headerBold: string;

  @Input()
  subheader: string;

  constructor() {}

  ngOnInit() {}
}
